import { State } from "@store/types";
import { PulsePollReportsFiltersStateProps } from "./reducers";

export function getPulsePollReportsFiltersState(state: State) {
  return state.getIn([
    "pulse_poll",
    "reportsFilters",
  ]) as PulsePollReportsFiltersStateProps;
}
